module.exports = __webpack_public_path__ + "img/map.0efc96fc.png";